// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { imageStyles } from "@tps/Overrides/Widgets/BrandDetails/BrandDetailsImage";
import { css } from "styled-components";

imageStyles.container = {};

imageStyles.imageItem = {
    css: css`
        margin-bottom: 32px;
    `,
};
imageStyles.linksItem = {
    css: css`
        display: flex;
        margin-bottom: 32px;
    `,
};

imageStyles.imageMissingText = {
    variant: "h1",
    css: css`
        width: 100%;
        overflow-wrap: break-word;
        word-wrap: break-word;
    `,
};

imageStyles.productLink = {
    variant: "primary",
    css: css`
        margin-right: 32px;
    `,
};

imageStyles.externalLink = {
    variant: "secondary",
};
